import { combineReducers } from '@reduxjs/toolkit'

import recommendReducer from '../pages/discover/cpms/recommend/store'
import rankingReducer from '../pages/discover/cpms/ranking/store'
import songsReducer from '../pages/discover/cpms/songs/store'
import djradioReducer from '../pages/discover/cpms/djradio/store'
import artistReducer from '../pages/discover/cpms/artist/store'
import albumReducer from '../pages/discover/cpms/album/store'
import playerReducer from '@/pages/player/store'

const cReducer = combineReducers({
    recommend: recommendReducer,
    ranking: rankingReducer,
    songs: songsReducer,
    djradio: djradioReducer,
    artist: artistReducer,
    album: albumReducer,
    player: playerReducer,
})

export default cReducer
